<template>
  <ValidationObserver ref='validationObserver'>
    <div id="dados-pessoas-form">
      <div class="new-form-row">
        <h3 class="new-form-legend">{{this.editing ? "Editando valor de doação" : "Criando valor de doação"}}</h3>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required"
          v-slot="{ errors }">
            <div class="new-form-input">
              <input
                name="value"
                v-model="value"
                type="number"
                placeholder="Valor"

              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

    </div>

    <div class="new-form-controls" >
      <div class="new-form-control">
        <button
          @click="validForm"
          class="new-form-button new-form-button-primary"
        > {{this.editing ? "Atualizar" : "Criar"}}
        </button>
      </div>
    </div>

  <div class="new-form-loading" v-if="this.isLoading"></div>
  </ValidationObserver>
</template>

<script>
import { setupAxios } from '../../setupAxios';
import { upsertDonationValues } from '../../apiClient';

export default {
  name: 'DonationValuesForm',
  props: {
    editing: { type: Boolean, default: false },
    id: { type: Number },
    amount: { type: Number },
    onClose: { type: Function }

  },
  data: function () {
    return {
      isLoading: false,
      value: 0
    };
  },
  async mounted () {
    this.axios = setupAxios(this.getValidationObserver());
    this.value = this.amount;
    console.log('this.$parent', this.$parent)
  },
  methods: {
    validForm: async function () {
      this.setLoading(true);
      const isValid = await (this.$refs.validationObserver.validate()) && await this.submit();
      this.setLoading(false);
      return isValid;
    },
    setLoading (isLoading) {
      this.isLoading = isLoading;
    },
    async submit () {
      return this.upsert();
    },
    async upsert () {
      const data = {
        id: this.id,
        amount: this.value
      };
      const res = await upsertDonationValues(this.axios, data);
      console.log('res', res);
      if (res && res.status === 200) {
        alert('Dados atualizados!');
        this.onClose(res.data.donationValue);
      }
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    }
  }
};
</script>
